import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from "react-dom/client";
import App from './App';
import { BrowserRouter,useHref, Routes, Route } from "react-router-dom";
import CancelPage from './CancelPage';
import PrivacyPolicy from './PrivacyPolicy';
import Terms from './Terms';
import Shipping from './Shipping';
import ResponsiveForm from './ResponsiveForm';
import Dashboard from './Dashboard';
import '@fontsource/roboto';
export default function Index() {
  return (
    <BrowserRouter>
      <Routes>
          <Route index element={<App />} />
          <Route path="/:merchantTransactionId/:email" element={<App />}  />
          <Route path="/:merchantTransactionId/:email/:data/:data1/:data2" element={<App />}  />
          <Route path="/cancel" element={<CancelPage />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/shipping" element={<Shipping />} />
          <Route path="/form" element={<ResponsiveForm />} />
          <Route path="/promoCode/:couponCode" element={<Dashboard/>} />
          <Route path="*" element={<App />} />
          
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Index />);

